import styled from 'styled-components'

import { CommonTextProps, commonTextStyle, } from '../utils'

export default styled.h1<CommonTextProps>`
  margin: 0;
  ${ commonTextStyle }
`
